import { render } from "./UserByShifts.vue?vue&type=template&id=6d4b684e&scoped=true"
import script from "./UserByShifts.vue?vue&type=script&lang=js"
export * from "./UserByShifts.vue?vue&type=script&lang=js"

import "./UserByShifts.vue?vue&type=style&index=0&id=6d4b684e&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/@vue/cli-service/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-6d4b684e"]])

export default __exports__